import { Routes } from '@angular/router';
import { authGuard } from './core/auth/auth.guard';
import { nonAuthGuard } from './core/auth/non-auth.guard';

export const routes: Routes = [
  { path: '', loadComponent: () => import('./features/home/home').then(m => m.HomeComponent) },
  { path: 'ads', loadComponent: () => import('./features/ads/ad-list/ad-list').then(m => m.AdList) },
  { path: 'ads/:id', loadComponent: () => import('./features/ads/ad-details/ad-details').then(m => m.AdDetails) },
  {
    path: 'account',
    canActivate: [authGuard],
    children: [
      { path: '', redirectTo: 'info', pathMatch: 'full' },
      { path: 'info', loadComponent: () => import('./features/account/info/info').then(m => m.Info) },
      { path: 'subscription', loadComponent: () => import('./features/account/subscription/subscription').then(m => m.Subscription) },
      { path: 'security', loadComponent: () => import('./features/account/security/security').then(m => m.Security) },
      { path: 'affiliate', loadComponent: () => import('./features/account/affiliate/affiliate').then(m => m.Affiliate) },
    ],
  },
  { path: 'helpdesk', loadComponent: () => import('./features/helpdesk/tickets/tickets').then(m => m.Tickets) },
  { path: 'helpdesk/create', loadComponent: () => import('./features/helpdesk/new-ticket/new-ticket').then(m => m.NewTicket) },
  { path: 'helpdesk/:id', loadComponent: () => import('./features/helpdesk/ticket/ticket').then(m => m.Ticket) },
  { path: 'login', loadComponent: () => import('./features/auth/login/login').then(m => m.Login) },
  {
    path: 'register',
    canActivate: [nonAuthGuard],
    loadComponent: () => import('./features/auth/register/register').then(m => m.Register),
  },
  {
    path: 'subscribe',
    canActivate: [nonAuthGuard],
    loadComponent: () => import('./features/auth/register/register').then(m => m.Register),
  },
  {
    path: 'verify-email',
    canActivate: [authGuard],
    loadComponent: () => import('./features/auth/verify-email/verify-email').then(m => m.VerifyEmail),
  },
  { path: 'examples', loadComponent: () => import('./features/ads/ad-list/ad-list').then(m => m.AdList) },
];
